import * as people from '../data/people.js';
import { closeCategories } from '../data/closeCategories.js';
import React from 'react';
import { boxSizes } from '../data/boxSizes.js';

function getPicture(guess) {
  return '/profile-pics/' + guess.toLowerCase() + '.png';
}

function generateBoxStates(guess, correctAnswer) {
  const boxStates = [];
  const guessedPerson = people[guess.toLowerCase()];
  const correctName = correctAnswer.name.toLowerCase();

  // loop over all attributes of guessedPerson, except for name
  for (const [key, value] of Object.entries(guessedPerson)) {
    let tempBoxState = 'blank';
    if (key === 'name') continue;
    if (key === 'country') continue;
    // If guess is correct, or if it's an array, sort it first then check again
    if (
      guessedPerson[key] === correctAnswer[key] ||
      (Array.isArray(guessedPerson[key]) &&
        Array.isArray(correctAnswer[key]) &&
        guessedPerson[key].sort().join(',') ===
          correctAnswer[key].sort().join(','))
    ) {
      tempBoxState = 'correct';
    } else {
      // If game list includes crossover
      if (
        key === 'favouriteGames' &&
        Array.isArray(guessedPerson[key]) &&
        guessedPerson[key].some((game) =>
          correctAnswer.favouriteGames.includes(game),
        )
      ) {
        tempBoxState = 'close';
      }

      // If year is within 2 years of the correct answer
      if (
        key === 'year' &&
        Math.abs(guessedPerson[key] - correctAnswer[key]) <= 2
      ) {
        tempBoxState = 'close';
      }

      if (['country', 'hairColour', 'activity'].includes(key)) {
        for (const category of closeCategories[key]) {
          if (
            category.includes(guessedPerson[key]) &&
            category.includes(correctAnswer[key])
          ) {
            tempBoxState = 'close';
            break;
          }
        }
      }
    }
    boxStates.push([value, tempBoxState, boxSizes[key]]);
  }

  // access user's guess (lowercase) by querying the people object

  return boxStates;
}

function GuessBoxes({ correctAnswer, guess, allGuesses }) {
  const guessesRemaining = allGuesses.reduce(function (n, val) {
    return n + (val === null);
  }, 0);
  const validGuesses = allGuesses.filter((g) => g !== null);
  if (guess !== null) {
    return (
      <div className="flex items-stretch justify-start gap-1 sm:justify-center sm:gap-3">
        {/* wrap the img so it centers in a stretched container */}
        <div className="flex flex-shrink-0 flex-col justify-center gap-1 pr-2 sm:pr-5">
          <img
            src={getPicture(guess)}
            alt={guess}
            className="h-auto w-12 rounded-lg object-cover sm:w-[3.75rem]"
          />
        </div>

        {generateBoxStates(guess, correctAnswer).map((boxState, i) => (
          <div
            key={i}
            className={`box blank ${boxState[1]} ${boxState[2]} flex h-auto flex-shrink-0 flex-col items-center justify-center px-1 text-xs font-semibold sm:px-2 sm:text-sm lg:flex-shrink lg:text-lg`}
          >
            {Array.isArray(boxState[0])
              ? boxState[0].map((game, idx) => (
                  <React.Fragment key={idx}>
                    <span className="text-center">{game}</span>
                  </React.Fragment>
                ))
              : boxState[0]}
          </div>
        ))}
      </div>
    );
  }

  // wrap your list in <>…</> (or another container) and drop the extra `{}`:
  return (
    <></>
    // <div className="flex h-15">
    //   {Array.from({ length: guessesRemaining }).map((_, i) => (
    //     <div class="box blank"></div>
    //   ))}
    // </div>
  );
}

export default GuessBoxes;
